// extracted by mini-css-extract-plugin
module.exports = {"online":"talkative_online__pJ0qh","talkativeOnline":"talkative_talkativeOnline__rPR38","talkativeOffline":"talkative_talkativeOffline__oW4cx"};